import {AfterViewInit, Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material';
import {merge} from 'rxjs/observable/merge';
import {BaseListComponent} from '../../SharedModule/BaseListComponent/base-list.component';
import {ProductTransferService} from '../../services/product-transfer.service';
import {BaseDataSource} from '../../model/DataSources/BaseDataSource';
import {Pagination} from '../../model/Helpers/Pagination';
import {SortInfo} from '../../model/Helpers/SortInfo';
import {Filter} from '../../model/Helpers/Filter';
import {ProductTransfer} from '../../model/Entities/ProductTransfer';

class ProductTransfersDataSource extends BaseDataSource<ProductTransfer> {
}

@Component({
    selector: 'product-transfers-list',
    templateUrl: './product-transfers-list.component.html',
    styleUrls: ['./product-transfers-list.component.scss']
})
export class ProductTransfersListComponent extends BaseListComponent implements AfterViewInit, OnChanges {
    @Input() productId: number = null;

    displayedColumns: string[] = ['created_at', 'user', 'direction', 'count', 'stock_after'];

    @ViewChild(MatSort) sort: MatSort;

    constructor(private productTransferService: ProductTransferService) {
        super();
        this.dataSource = new ProductTransfersDataSource(this.productTransferService);
        this.pageSize = 25;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.productId && !changes.productId.firstChange && this.productId && this.paginator) {
            this.loadData();
        }
    }

    ngAfterViewInit(): void {
        if (!this.productId) {
            return;
        }
        this.prepareDataLoading();
        this.loadData();
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }

    prepareDataLoading(): void {
        merge(this.paginator.page, this.sort.sortChange, this.dataChangedEventSubject).subscribe(() => {
            if (!this.dataSource || !this.productId) {
                return;
            }
            this.dataSource.loadPage(
                new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                new SortInfo(this.sort.active, this.sort.direction),
                this.getFilters()
            );
        });
    }

    loadData(): void {
        if (!this.productId || !this.paginator) {
            return;
        }
        this.dataSource.loadPage(
            new Pagination(this.paginator.pageSize, this.pageSize * this.initialPageIndex),
            this.sort ? new SortInfo(this.sort.active, this.sort.direction) : new SortInfo('created_at', 'desc'),
            this.getFilters()
        );
    }

    getFilters(): Filter[] {
        return [new Filter('product_id', this.productId)];
    }

    getDirectionLabel(transfer: ProductTransfer): string {
        if (transfer.movementType === 'initial') {
            return 'Počáteční stav';
        }
        if (transfer.movementType === 'loss') {
            return 'Ztráta';
        }
        return transfer.count >= 0 ? 'Naskladnění' : 'Vyskladnění';
    }
}



// WEBPACK FOOTER //
// /app/src/ProductsModule/ProductTransfersListComponent/product-transfers-list.component.ts